export const SmartWaiter = {
  basketNote: {},
  themeVenueLogo: 'sw_logo.png'
}
